import $ from "jquery";

document.addEventListener("DOMContentLoaded", function (event) {
  $(".wp-block-button.is-style-vertical").click(function () {
    let _t = $(this);
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: _t.closest(".wp-block-cover").next("div").offset().top,
      },
      1000
    );
  });

  //Input label interaction
  const formItems = $(".form-item");
  if (formItems.length) {
    formItems.each(function () {
      const el = $(this);

      el.on("focus", 'input:not([type="submit"]):not([type="checkbox"]):not([type="radio"]), textarea', function () {
        let _t = $(this);
        _t.closest(".form-item").addClass("is-focused");
      });

      el.on("blur", 'input:not([type="submit"]):not([type="checkbox"]):not([type="radio"]), textarea', function () {
        let _t = $(this);
        if (_t.val().trim() === "") {
          _t.closest(".form-item").removeClass("is-focused");
        }
      });
    });
  }
});
